// Topics Store
import { some } from 'lodash'
import store from 'customerPath/store'

const state = {
  pending: false,
  status: null,
  topic: {},
  topicSuggestions: [],
}

const getters = {
  canDeleteTopic: ({ topic }) => topic && some(topic.permissions, p => p === 'delete'),
  canEditTopic: ({ topic }) => topic && some(topic.permissions, p => p === 'edit'),
  canPostContent: ({ topic }) => topic && some(topic.permissions, p => p === 'post_content'),
}

const actions = {
  getTopic({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING')
      this.api.items
      .getItem(`topics.${id}`)
      .then(({ data }) => {
        if (data.status && data.status === -1) {
          commit('REQUEST_FAILED', data.status)
          resolve(data.status)
        }
        commit('SET_TOPIC', data)
        commit('SET_PENDING')
        resolve()
      }).catch(({ response }) => {
        store.dispatch('app/setError', response.status)
        reject(response)
      })
    })
  },
  getTopicSuggestions({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .getItems('topics.suggestions')
      .then(({ data }) => {
        commit('SET_TOPIC_SUGGESTIONS', data.results)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  getTopicMembers({ commit }, { id, options }) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING')
      this.api.items
      .getItems(`topics/${id}/users`, options)
      .then(({ data }) => {
        if (data.status && data.status === -1) {
          commit('REQUEST_FAILED', data.status)
        }

        commit('SET_TOPIC_MEMBERS', data)
        commit('SET_PENDING')
        resolve()
      }).catch(({ response }) => {
        store.dispatch('app/setError', response.status)
        reject(response)
      })
    })
  },
  acceptSuggestion({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .editItem(`topics.suggestions.${id}`)
      .then(_ => {
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  declineSuggestion({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .deleteItem(`topics.suggestions.${id}`)
      .then(_ => {
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  deleteTopic({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .deleteItem(`topics.${id}`)
      .then(_ => {
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  createTopic({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .createItem('topics', payload)
      .then(data => {
        if (data.status && data.status === -1) {
          resolve(data.status)
        }

        commit('CREATE_TOPIC')
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  checkTopic({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING')
      this.api.items
      .getItem(`topics.${id}`)
      .then(({ data }) => {
        if (data.status && data.status === -1) {
          commit('REQUEST_FAILED', data.status)
          resolve(data.status)
        }

        commit('SET_TOPIC', data)
        commit('SET_PENDING')
        resolve()
      }).catch(({ response }) => {
        store.dispatch('app/setError', response.status)
        reject(response)
      })
    })
  },
  editTopic({ commit }, { id, payload }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .editItem(`topics.${id}`, payload)
      .then(_ => {
        commit('EDIT_TOPIC')
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  createTopicSuggestion({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .createItem('topics.suggestions', payload)
      .then(_ => {
        commit('CREATE_TOPIC_SUGGESTION')
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  clearTopic({ commit }) {
    commit('CLEAR_TOPIC')
  },
  clearTopicMembers({ commit }) {
    commit('CLEAR_TOPIC_MEMBERS')
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  CLEAR_TOPIC(state) {
    state.topic = {}
  },
  CLEAR_TOPIC_MEMBERS(state) {
    state.topic.members = { results: [], pagination: {} }
  },
  CREATE_TOPIC() {
    return true
  },
  EDIT_TOPIC() {
    return true
  },
  CREATE_TOPIC_SUGGESTION() {
    return true
  },
  REQUEST_FAILED(state, payload) {
    state.status = payload
  },
  SET_TOPIC_MEMBERS(state, payload) {
    state.topic.members.results.push(...payload.results)
    state.topic.members.pagination = payload.pagination
  },
  SET_TOPIC: (state, { results }) => {
    state.topic = results
  },
  SET_TOPIC_SUGGESTIONS: (state, payload) => {
    state.topicSuggestions = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
